export const SESSION_ID_KEY = 'intake_v2.5_session_id';

export const isValidSessionId = (id: unknown): id is string =>
  id != null && typeof id === 'string' && id.length > 0;

export const getStoredSessionId = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const id = localStorage.getItem(SESSION_ID_KEY);

    if (id && !isValidSessionId(id)) {
      localStorage.removeItem(SESSION_ID_KEY);
      return null;
    }
    return id;
  } catch {
    return null;
  }
};

export const storeSessionId = (sessionId: string) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (!isValidSessionId(sessionId)) {
    console.error('Attempted to store invalid session ID:', sessionId);
    return;
  }

  try {
    localStorage.setItem(SESSION_ID_KEY, sessionId);
  } catch (error) {
    console.error('Failed to store session ID:', error);
  }
};

export const clearSessionId = () => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.removeItem(SESSION_ID_KEY);
  } catch (error) {
    console.error('Failed to remove session ID:', error);
  }
};

export const clearWizardSession = () => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.removeItem(SESSION_ID_KEY);
  } catch (error) {
    console.error('Failed to clear wizard session:', error);
  }
};
